import { useContext } from "react";
import { BSTInsightsAppContext } from "../../../layouts/PageLayout";
import { RolesEnum } from "../../../utils/roles";

/**
 * useProfileMenu
 *
 * @returns
 *
 *```
 *{
 *  showInsightAppSettingsModal,
 *  showUserManagementModal,
 *  handleShowInsightAppSettingModal,
 *  handleShowUserManagement
 *}
 *```
 *
 **/
const useProfileMenu = () => {
  const { UserInformation, UserRoles } = useContext(BSTInsightsAppContext);

  const showUserManagement =
    UserRoles.length > 1 &&
    UserRoles.some((item) => item.roleId === RolesEnum.AccountOwner);

  const showInsightAppSettings = UserRoles.some(
    (item) =>
      item.roleId === RolesEnum.AccountOwner ||
      item.roleId === RolesEnum.ProjectAdministrator
  );

  const userRoles = UserRoles.map((item) => item.roleName);

  return {
    showUserManagement,
    userRoles,
    UserInformation,
    showInsightAppSettings,
  };
};
export default useProfileMenu;
